"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVariant = void 0;
const createVariant = (resolver) => {
    return (calculator) => (props) => {
        const resolvedBranch = resolver(props)(props);
        return calculator ? calculator(resolvedBranch, props) : resolvedBranch;
    };
};
exports.createVariant = createVariant;
//# sourceMappingURL=createVariant.js.map